import { render, staticRenderFns } from "./ModalChangeOrder.vue?vue&type=template&id=8fa22e4e&"
import script from "./ModalChangeOrder.vue?vue&type=script&lang=ts&"
export * from "./ModalChangeOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports